import React from 'react';
import { audiences, bonuses } from '../data/coachSystem';
import { SectionEyebrow } from './SectionEyebrow';
export function BonusSection() {
  return <section className="bg-char py-11 sm:py-14" aria-labelledby="bonus-title" data-id="element-13" data-mp="1ohycztgox6z6">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-14" data-mp="22f3erh9dfjom">
        <SectionEyebrow label="And that’s just the core system" data-id="element-15" data-mp="1yfcrvomytnpd" />
        <h2 id="bonus-title" className="mt-4 font-display text-[1.8rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.3rem]" data-id="element-16" data-mp="1anxkvik8ui7s">
          You also get 5 practical coaching bonuses.
        </h2>

        <ol className="mt-7 grid grid-cols-2 gap-3.5 sm:grid-cols-3 sm:gap-5" data-id="element-17" data-mp="1ji29dvbwnhk5">
          {bonuses.map(bonus => <li key={bonus.number} className={`flex h-full flex-col rounded-xl border border-char-line bg-char-light p-4 text-center shadow-card sm:p-5 ${bonus.number === 5 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-18" data-mp="1eo7paqse10kj">
              <p className="font-display text-[0.64rem] font-semibold uppercase tracking-[0.26em] text-orange" data-id="element-19" data-mp="29q0e0yyyo48k">
                Bonus {bonus.number}
              </p>
              <span className="mx-auto mt-2.5 block h-[2px] w-7 rounded-full bg-orange/70" aria-hidden="true" data-id="element-20" data-mp="2jixrurt0d50u" />
              <h3 className="mt-2.5 font-display text-[0.95rem] font-semibold uppercase leading-tight text-ivory sm:text-[1.05rem]" data-id="element-21" data-mp="1qt8ow8wqmuwl">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[0.76rem] leading-relaxed text-ivory-muted sm:text-[0.84rem]" data-id="element-22" data-mp="1vu51dav5npdm">
                {bonus.description}
              </p>
            </li>)}
        </ol>

        <div className="mt-9 border-t border-char-line pt-7" data-id="element-23" data-mp="25oetqsk3knoc">
          <span className="mx-auto mb-3.5 block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-24" data-mp="3c5s6h8359a6e" />
          <h3 className="font-display text-[0.72rem] font-semibold uppercase text-orange" style={{
          letterSpacing: '0.24em'
        }} data-id="element-25" data-mp="3h7hkmwlny3yp">
            Built for
          </h3>
          <ul className="mt-3.5 flex flex-wrap items-center justify-center gap-2" data-id="element-26" data-mp="1c6olkzou89j6">
            {audiences.map(item => <li key={item} className="rounded-full border border-char-line bg-char-light px-3.5 py-1.5 text-[0.82rem] font-medium text-ivory-soft shadow-card" data-id="element-27" data-mp="1m2roi7rikc76">
                {item}
              </li>)}
          </ul>
          <p className="mx-auto mt-5 max-w-2xl text-[0.92rem] leading-relaxed text-ivory-muted" data-id="element-28" data-mp="tbzungxx7zn0">
            A practical coaching library for developing and experienced coaches
            alike — anyone who wants greater organization and ready-to-use
            resources across the season.
          </p>
        </div>
      </div>
    </section>;
}